import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getMember } from '../data/team';
import NotFoundPage from './NotFoundPage';
import './TeamMemberPage.css';

// Long single-string bios read badly as one block; break them into paragraphs
// of a few sentences. Avoids regex lookbehind for older Safari.
function toParagraphs(text, sentencesPerParagraph = 3) {
  const parts = text.split(/\.\s+/);
  const sentences = parts.map((s, i) => (i === parts.length - 1 ? s : `${s}.`));
  const paragraphs = [];

  for (let i = 0; i < sentences.length; i += sentencesPerParagraph) {
    paragraphs.push(sentences.slice(i, i + sentencesPerParagraph).join(' '));
  }

  return paragraphs;
}

function TeamMemberPage() {
  const { slug } = useParams();
  const { language } = useLanguage();
  const member = getMember(slug);

  if (!member) {
    return <NotFoundPage />;
  }

  const isEn = language === 'en';
  const role = isEn ? member.titleEn : member.title;
  const bio = isEn ? member.bioEn : member.bio;

  return (
    <div className="member-page">
      <div className="container">
        <nav className="member-breadcrumb" aria-label={isEn ? 'Breadcrumb' : 'Miga de pan'}>
          <Link to="/">{isEn ? 'Home' : 'Inicio'}</Link>
          <span aria-hidden="true">/</span>
          <Link to="/equipo">{isEn ? 'Team' : 'Equipo'}</Link>
          <span aria-hidden="true">/</span>
          <span className="member-breadcrumb-current">{member.name}</span>
        </nav>

        <article className="member-profile">
          <div className="member-photo">
            <img
              src={`${process.env.PUBLIC_URL}/${member.image}`}
              alt={member.name}
              width="600"
              height="800"
            />
          </div>

          <div className="member-body">
            <h1 className="member-name">{member.name}</h1>
            <p className="member-role">{role}</p>

            {bio ? (
              toParagraphs(bio).map((paragraph, i) => (
                <p key={i} className="member-bio">{paragraph}</p>
              ))
            ) : (
              <p className="member-bio">
                {isEn
                  ? `${member.name} is part of the Tabia Group team as ${member.titleEn}.`
                  : `${member.name} forma parte del equipo de Tabia Group como ${member.title}.`}
              </p>
            )}

            <Link to="/equipo" className="member-back">
              {isEn ? '← Back to the team' : '← Volver al equipo'}
            </Link>
          </div>
        </article>
      </div>
    </div>
  );
}

export default TeamMemberPage;
